export enum AppointmentStatus {
    Waiting = 1,
    InProgress = 2,
    PendingValidation = 3,
    Done = 4,
    Cancel = 5,
    Unexpected = 6,
}
